var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useSearchReducer } from "../use-search-reducer";
import { useSearchActions } from "../use-search-actions";
import { useResultState } from "../use-result-state";
import { useFilterStateWithClearSearch, useSearchActionsWithUpdateFilters } from "../use-filter-state";
import { useHydrateFiltersLookups } from "../use-filter-state/use-hydrate-filters-lookups";
import { useOnClearSearch } from "./use-on-clear-search";
import { useInitialResultStatus } from "../use-initial-search-state";
var emptyObject = {};
export var useSearchState = function (initialState, onClearSearch, onSearchUpdated, onSearchAction, getCriteriaFromPage, filters, lookupInfo, defaultCriteria) {
    var _a, _b, _c, _d, _e, _f, _g;
    var initialSearchState = initialState.searchState;
    var initialCriteria = useRef((_b = (_a = initialSearchState.search) === null || _a === void 0 ? void 0 : _a.criteria) === null || _b === void 0 ? void 0 : _b.criteria);
    var _h = useHydrateFiltersLookups(initialCriteria.current, filters, lookupInfo === null || lookupInfo === void 0 ? void 0 : lookupInfo.fetchLookupInfo, (_c = lookupInfo === null || lookupInfo === void 0 ? void 0 : lookupInfo.initialState) !== null && _c !== void 0 ? _c : emptyObject, defaultCriteria), currentLookupInfo = _h.lookupInfo, setLookupInfo = _h.setLookupInfo, rehydrateFilterLookups = _h.rehydrateFilterLookups;
    var initialResultState = useMemo(function () {
        var _a, _b;
        return ({
            result: (_a = initialState.result) !== null && _a !== void 0 ? _a : {},
            selection: (_b = initialState.selection) !== null && _b !== void 0 ? _b : [],
        });
    }, [initialState.result, initialState.selection]);
    var resultState = useResultState(initialResultState);
    var _j = useOnClearSearch(onClearSearch, resultState.selectionActions.unselectAllItems), clearSearchId = _j.clearSearchId, onResetSearch = _j.onResetSearch;
    var _k = useFilterStateWithClearSearch((_e = (_d = initialSearchState.search) === null || _d === void 0 ? void 0 : _d.criteria) === null || _e === void 0 ? void 0 : _e.criteria, filters, rehydrateFilterLookups, onResetSearch), activeFilters = _k.activeFilters, updateFilters = _k.updateFilters, refreshAllFilters = _k.refreshAllFilters, onClearSearchState = _k.onClearSearchState;
    var pageSizeRef = useRef(initialSearchState.pager.pageSize);
    var onGetCriteriaFromPage = useCallback(function (pageNumber, pageSize, criteria) {
        return getCriteriaFromPage === null || getCriteriaFromPage === void 0 ? void 0 : getCriteriaFromPage(pageNumber, pageSize !== null && pageSize !== void 0 ? pageSize : pageSizeRef.current, criteria);
    }, [getCriteriaFromPage]);
    var _l = useSearchReducer(initialSearchState, onClearSearchState, onGetCriteriaFromPage), searchState = _l[0], dispatch = _l[1];
    pageSizeRef.current = searchState.pager.pageSize;
    var actions = useSearchActions(dispatch, onSearchAction);
    var searchActions = useSearchActionsWithUpdateFilters((_g = (_f = searchState === null || searchState === void 0 ? void 0 : searchState.search) === null || _f === void 0 ? void 0 : _f.criteria) === null || _g === void 0 ? void 0 : _g.criteria, actions, updateFilters, refreshAllFilters, rehydrateFilterLookups);
    var state = useMemo(function () { return (__assign({ searchState: searchState, searchActions: searchActions, clearSearchId: clearSearchId }, resultState)); }, [clearSearchId, resultState, searchActions, searchState]);
    var initialResultStatus = useInitialResultStatus(initialState.result);
    useEffect(function () {
        onSearchUpdated && onSearchUpdated(state);
    }, [state, onSearchUpdated]);
    return {
        state: state,
        activeFilters: activeFilters,
        lookupInfo: currentLookupInfo,
        setLookupInfo: setLookupInfo,
        initialResultStatus: initialResultStatus,
    };
};
//# sourceMappingURL=use-search-state.js.map